__webpack_public_path__ = window.__webpack_public_path__; // eslint-disable-line

import * as Sentry from "@sentry/browser";
import Global from "./theme/global";

Sentry.init({
  dsn: ENV_SENTRY_DSN,
  environment: ENV_SENTRY_ENV,
  tracesSampleRate: 0.1,
  integrations: [Sentry.replayIntegration()],
});

// Expose Sentry to the window for manual error reporting
window.Sentry = Sentry;

const getAccount = () => import("./theme/account");
const getLogin = () => import("./theme/auth");
const { v4: uuidv4 } = require("uuid");

const noop = null;

const pageClasses = {
  account_orderstatus: getAccount,
  account_order: getAccount,
  account_addressbook: getAccount,
  shippingaddressform: getAccount,
  account_new_return: getAccount,
  "add-wishlist": () => import("./theme/wishlist"),
  account_recentitems: getAccount,
  account_downloaditem: getAccount,
  editaccount: getAccount,
  account_inbox: getAccount,
  account_saved_return: getAccount,
  account_returns: getAccount,
  account_paymentmethods: getAccount,
  account_addpaymentmethod: getAccount,
  account_editpaymentmethod: getAccount,
  login: getLogin,
  createaccount_thanks: getLogin,
  createaccount: getLogin,
  getnewpassword: getLogin,
  forgotpassword: getLogin,
  blog: noop,
  blog_post: noop,
  brand: () => import("./theme/brand"),
  brands: noop,
  cart: () => import("./theme/cart"),
  category: () => import("./theme/category"),
  compare: () => import("./theme/compare"),
  page_contact_form: () => import("./theme/contact-us"),
  error: noop,
  404: noop,
  giftcertificates: () => import("./theme/gift-certificate"),
  giftcertificates_balance: () => import("./theme/gift-certificate"),
  giftcertificates_redeem: () => import("./theme/gift-certificate"),
  default: noop,
  page: noop,
  product: () => import("./theme/product"),
  amp_product_options: () => import("./theme/product"),
  search: () => import("./theme/search"),
  rss: noop,
  sitemap: noop,
  newsletter_subscribe: noop,
  wishlist: () => import("./theme/wishlist"),
  wishlists: () => import("./theme/wishlist"),
};

const customClasses = {};

function loadRiskifiedBeacon() {
  let sessionId = null;
  const riskifiedSessionId = localStorage.getItem("riskified_session_id");
  if (riskifiedSessionId) {
    sessionId = riskifiedSessionId;
  } else {
    sessionId = uuidv4();
    localStorage.setItem("riskified_session_id", sessionId);
  }
  const storeDomain = "wegift.io";

  if (!storeDomain) {
    console.warn("Riskified store domain not defined");
    return;
  }

  const beaconSrc = `https://beacon.riskified.com/?shop=${storeDomain}&sid=${sessionId}`; // Use sessionId, not uuidv4

  if (!document.querySelector(`script[src="${beaconSrc}"]`)) {
    const script = document.createElement("script");
    script.src = beaconSrc;
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);
  }
}

/**
 * This function gets added to the global window and then called
 * on page load with the current template loaded and JS Context passed in
 * @param pageType String
 * @param contextJSON
 * @returns {*}
 */
window.stencilBootstrap = function stencilBootstrap(
  pageType,
  contextJSON = null,
  loadGlobal = true
) {
  const context = JSON.parse(contextJSON || "{}");

  return {
    load() {
      $(() => {
        // Load globals
        if (loadGlobal) {
          Global.load(context);
        }

        loadRiskifiedBeacon();

        const importPromises = [];

        // Find the appropriate page loader based on pageType
        const pageClassImporter = pageClasses[pageType];
        if (typeof pageClassImporter === "function") {
          importPromises.push(pageClassImporter());
        }

        // See if there is a page class default for a custom template
        const customTemplateImporter = customClasses[context.template];
        if (typeof customTemplateImporter === "function") {
          importPromises.push(customTemplateImporter());
        }

        // Wait for imports to resolve, then call load() on them
        Promise.all(importPromises).then((imports) => {
          imports.forEach((imported) => {
            imported.default.load(context);
          });
        });

        if (window.location.pathname === "/all-products/") {
          const bannerSliderObserver = new MutationObserver(
            (mutations, obs) => {
              const targetElement = document.querySelector(".banner-slider");

              if (targetElement) {
                $(".banner-slider").slick({
                  infinite: true,
                  arrows: false,
                  mobileFirst: true,
                  dots: true,
                  autoplay: window.banner_autoplay,
                  autoplaySpeed: window.banner_autoplay_speed,
                  speed: 1250,
                  nextArrow: `<button type="button" class="banner-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg></button>`,
                  prevArrow: `<button type="button" class="banner-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></button>`,
                  responsive: [
                    {
                      breakpoint: 801,
                      settings: {
                        dots: false,
                        arrows: true,
                        mobileFirst: false,
                      },
                    },
                  ],
                });
                obs.disconnect();
              }
            }
          );

          bannerSliderObserver.observe(document.body, {
            childList: true,
            subtree: true,
          });
        }
      });
    },
  };
};
